import RewardsCustomerActiveRewardsQuery from "@apps/rewards/modules/CustomerRewards/queries/RewardsCustomerActiveRewardsQuery";
import RewardsCustomerRewardsService from "@apps/rewards/modules/CustomerRewards/services/RewardsCustomerRewardsService";
import RewardsDiResolverService from "@apps/rewards/services/RewardsDiResolverService/RewardsDIResolverService";
import type { SvelteComponent } from "svelte";
import { injectable } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";
import type { WidgetInterface } from "@interfaces/WidgetInterface";

import RewardsAvailableRewardsListWidgetComponent from "./RewardsAvailableRewardsListWidget.svelte";
import type { AvailableRewardsListWidgetConfig } from "./types";

@injectable()
class RewardsAvailableRewardsListWidget implements WidgetInterface {
    private component: SvelteComponent | undefined = undefined;

    constructor(
        private readonly config: AvailableRewardsListWidgetConfig,
        private readonly logger: LoggerInterface
    ) {
        this.logger.debug(
            "RewardsAvailableRewardsListWidget is initialized",
            config
        );
    }

    init(): this {
        const diResolverService = new RewardsDiResolverService();
        const { customerRewardsService, customerActiveRewardsQuery } =
            diResolverService.resolveAll({
                customerRewardsService: RewardsCustomerRewardsService,
                customerActiveRewardsQuery: RewardsCustomerActiveRewardsQuery,
            });

        this.component = new RewardsAvailableRewardsListWidgetComponent({
            target: this.config.target,
            props: {
                customerRewardsService,
                customerActiveRewardsQuery,
                locale: this.config.locale,
                onChange: this.config.onChange,
            },
        });

        return this;
    }

    destroy() {
        if (this.component) {
            this.component.$destroy();
        }
    }
}

export default RewardsAvailableRewardsListWidget;
